// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"sLmNSeO3wVdwwftG4BT5L"};